import { Component, OnInit } from '@angular/core';
import { ReviewService } from 'src/app/services/review.service';
import { BehaviorSubject } from 'rxjs';
import { FilterOption } from 'src/app/models/filter-option';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss']
})
export class ReviewsComponent implements OnInit {
  private perPage=20;
  public loading:boolean=true;
  public paginatedReviews = new BehaviorSubject<any>(null);
  public availableFilters=[];
  private filterString:string='filter[status]';
  private ratingFilter:number=0;

  public allColumns = [
    { value: 'course_title',    label: 'Course' },
    { value: 'review',          label: 'Review' },
    { value: 'rating',          label: 'Rating' },
    { value: 'status',          label: 'Status' },
    { value: 'applicant_name',  label: 'User' },
    { value: 'applicant_email', label: 'Email' },
    { value: 'date_created',    label: 'Date' },
  ];
  public selectedColumns: string[] = ['course_title', 'review', 'rating', 'status'];

  constructor(
    private _review: ReviewService
  ) {
    this.availableFilters.push(new FilterOption({name:'review',type:'string'}));
    this.availableFilters.push(new FilterOption({
      name:'status',
      type:'select',
      'options':[
        {name:'Pending',value:'pending'},
        {name:'Moderated',value:'moderated'},
        {name:'Rejected', value:'rejected'}
      ],
      default: 'pending'
    }));
    this.availableFilters.push(new FilterOption({
      name:'rating',
      type:'select',
      'options':[
        {name:'Any',value:0},
        {name:'1 star',value:1},
        {name:'2 stars',value:2},
        {name:'3 stars',value:3},
        {name:'4 stars',value:4},
        {name:'5 stars',value:5}
      ],
      default:0
    }));
  }

  getReviews(page){
    this._review.getReviews(page, this.perPage, this.filterString).subscribe(
      paginatedData=>{
        this.paginatedReviews.next(paginatedData);
        this.loading=false;
      }
    );
  }

  ngOnInit() {
    this.getReviews(1);
  }

  filterChanged(filters){
    if(filters.includes('[rating]')) {
      let start=(filters.indexOf('[rating]')+9);
      this.ratingFilter=filters.substr(start,1);
    }
    this.filterString = filters;
    this.getReviews(1);
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getReviews(data.pageIndex+1);
  }

  perPageChanged(data){
    this.perPage=data.pageSize;
    this.getReviews(1);
  }

  approveAllPending(){
    if(!confirm('Are you sure you want to approve ALL pending reviews shown in the table?')) return;
    this._review.approveAllPending(this.ratingFilter).subscribe(
      res=>{
        this.getReviews(1);
      }
    );
  }

  rejectAllPending(){
    if(!confirm('Are you sure you want to reject ALL pending reviews shown in the table?')) return;
    this._review.rejectAllPending(this.ratingFilter).subscribe(
      res=>{
        this.getReviews(1);
      }
    );
  }

  exportCSV(){
    this._review.getReviews(1, 9999, this.filterString).subscribe(
      (data: any) => {
        const reviews = data.data || [];
        if(!reviews.length){ alert('No reviews to export.'); return; }

        const colMap: {[key: string]: {header: string, val: (r: any) => any}} = {
          course_title:    { header: 'Course',  val: r => r.course ? (r.course.title || '') : (r.stream ? (r.stream.title || '') : '') },
          review:          { header: 'Review',  val: r => '"' + (r.review || '').replace(/"/g, '""') + '"' },
          rating:          { header: 'Rating',  val: r => r.rating || '' },
          status:          { header: 'Status',  val: r => r.status || '' },
          applicant_name:  { header: 'User',    val: r => r.user ? (r.user.first_name + ' ' + r.user.last_name).trim() : '' },
          applicant_email: { header: 'Email',   val: r => r.user ? (r.user.email || '') : '' },
          date_created:    { header: 'Date',    val: r => r.created_at ? r.created_at.substr(0,10) : '' },
        };
        const cols = this.selectedColumns.filter(c => colMap[c]);
        const headers = ['ID', ...cols.map(c => colMap[c].header)];
        const rows = reviews.map(r => [r.id || '', ...cols.map(c => colMap[c].val(r))]);

        const csv = [headers.join(','), ...rows.map(row => row.join(','))].join('\n');
        const blob = new Blob(['﻿' + csv], {type: 'text/csv;charset=utf-8;'});
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'reviews_export.csv';
        a.click();
        URL.revokeObjectURL(url);
      }
    );
  }
}
